import { useCallback } from 'react'

import { useLocation, useNavigate } from 'Pods/Shared/ContextBasedRouter'
import { STUDIO_PATH } from 'Pods/ThreeDStudio/constants'
import { parseGeneratingRunId } from 'Pods/ThreeDStudio/Hooks/generatingRunUrl'
import { clearModelSettings } from 'Pods/ThreeDStudio/Store/actions/modelSettings'

// Opens the 3D generator on its empty starting page. Stays usable at the concurrency cap:
// hitting the cap only blocks starting another run, not reaching the page - which the top
// navigation reaches anyway. The cap messaging lives on the Generate button there instead.
export default function useGenerateNewModel(onNavigate) {
  const navigate = useNavigate()
  const location = useLocation()

  return useCallback(() => {
    clearModelSettings()
    // Compare the search string too, so coming back from /ai?run=<id> still navigates and
    // drops the parameter - otherwise the generating card stays selected instead of the new one.
    if (`${location?.pathname ?? ''}${location?.search ?? ''}` !== STUDIO_PATH.GENERATE) {
      navigate(STUDIO_PATH.GENERATE)
    }
    onNavigate('new')
  }, [navigate, location, onNavigate])
}

// Whether the generator's empty starting page is what the location shows: /ai alone means
// "composing a new generation", but /ai?run=<id> means the user is watching that run's card.
export const isNewModelPage = location => location?.pathname === STUDIO_PATH.GENERATE
  && parseGeneratingRunId(location?.search ?? '') == null
